import { ref, uploadBytesResumable } from "firebase/storage";
import { useState } from "react";
import { storageService } from "../../firebase-config";

export function useUploadResource() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);

  const uploadResource = async (file: File, capacityId: string) => {
    setUploading(true);
    setError(null);

    try {
      let resourceType: "VIDEO" | "PDF" | "MANUAL" | "LINK" = "LINK";
      if (file.type.includes("video")) resourceType = "VIDEO";
      else if (file.type.includes("pdf")) resourceType = "PDF";
      else if (file.type.includes("image")) resourceType = "MANUAL";

      const fileName = `${Date.now()}_${file.name}`;
      const path = `resources/${capacityId}/${fileName}`;
      const storageRef = ref(storageService, path);

      const uploadTask = uploadBytesResumable(storageRef, file);

      return await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const pct = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress(pct);
          },
          (err) => {
            setError(err.message);
            setUploading(false);
            reject(err);
          },
          async () => {
            const { bucket, fullPath } = uploadTask.snapshot.ref;
            const url = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
              fullPath
            )}?alt=media`;

            const resource = {
              id: Date.now().toString(),
              capacityId,
              resourceType,
              title: file.name.replace(/\.[^/.]+$/, ""),
              description: "",
              url,
              thumbnailUrl: resourceType === "VIDEO" ? "" : url,
              createdAt: new Date().toISOString(),
            };

            setUploading(false);
            setProgress(100);
            resolve(resource);
          }
        );
      });
    } catch (err: any) {
      setError(err.message);
      setUploading(false);
      throw err;
    }
  };

  return { uploadResource, uploading, progress, error };
}
